import controls from '../curriculum/print-controls.json';
import { esc } from './dom';
export type PrintAudience='student'|'key';
export const printLabel=(audience:PrintAudience):string=>controls.outputs.find(o=>o.id===audience)!.label;
export function printButton(audience:PrintAudience,id='print'):string{return `<button type="button" id="${esc(id)}">${esc(printLabel(audience))}</button>`;}
